/* eslint-disable max-len */
module.exports = {
  // Translations in this namespace are simple noun.
  account: 'Account',
  account_id: 'Account ID',
  owner_account_id: 'Root Account ID',
  sub_account_id: 'Sub Account ID',
  grid: 'Grid',
  list: 'List',
  name: 'Name',
  file: 'File',
  folder: 'Folder',
  local_file: 'Local File',
  local_folder: 'Local Folder',
  file_or_folder: 'File / Folder',
  count_file_or_folder: '{count} file / folder',
  file_name: 'Name',
  folder_name: 'Folder Name',
  basic_info: 'Basic Info',
  location: 'Location',
  size: 'Size',
  status: 'Status',
  curr_status: 'Current Status',
  action: 'Action',
  remark: 'Remark',
  mtime: 'Last Modified',
  ctime: 'Create time',
  share: 'Share',
  all: 'All',
  empty: '-',
  remain: 'remain',
  count_unit: '',
  time_unit: {
    ms: 'ms',
    s: 's',
    min: 'minutes',
    h: 'hours',
    d: 'days',
    y: 'years',
  },
  status_code: 'Status Code',
  storage_method: 'Storage method',
  url_link: 'Url link',
  file_detail: 'Detail',
  file_path: 'Path',
  default_title: 'Warning',
  cloud_account_warning: 'Login using permanent keys is not permitted for Cloud Ladder accounts. Please use a temporary access key or your password',
  tencent_cloud_account: 'Tencent Cloud Account > Sub Account',
  login_prompt: 'Log in!',
  login_title: 'Log in COSBrowser',
  login_failed: 'Log in failed',
  return_to_login: 'Back to log in',
  missing_parameters: 'Missing parameter(s)',
  file_size_exceeded: 'The file size exceed the limit.Each file no bigger than {maxSize}.',
  auth_failed: 'Authorization failed, please log in again. (Do not refresh the page during authorization process)',
  default_msg: 'Prompt',
  success: '{msg} successfully.',
  fail: '{msg} failed.',
  root: 'Bucket List',
  failure_list_type: '{type} failure list',
  statistics: 'Statistics',
  total: 'Total',
  storage: 'Storage',
  link_type: 'Link type',
  url_type: 'URL Type',
  resource: 'Resources',
  path: 'Path',
  editor_history: 'History',
  original_name: 'Original file (folder) name',
  off: 'Off',
  on: 'On',
  opened: 'Opened',
  unopened: 'Unopened',
  valid_time: 'Valid time',
  expire_time: 'Expired Time',
  extract_code: 'Extraction code',
  table_layout: 'Table layout',
  grid_layout: 'Grid layout',
  download_instructions: 'Download Instructions',
  editor_mode: 'Editor Mode',
  standard_mode: 'Standard Mode',
  description: 'Description',
  rule: 'Rule',
  type: 'Type',

  // Translations in this namespace are simple actions.
  key_login: 'Key Login',
  login: 'Login',
  logout: 'Logout',
  switch_session: 'Switch Session',
  copy: 'Copy',
  move: 'Move',
  copyTo: 'Copy to',
  moveTo: 'Move to',
  paste: 'Paste',
  restore: 'Restore',
  del: 'Del',
  remove: 'Delete',
  delete: 'Delete',
  delete_param: 'Delete {param}',
  select: 'Selete',
  select_all: 'Select All',
  edit: 'Edit',
  refresh: 'Refresh',
  ok: 'OK',
  cancel: 'Cancel',
  close: 'Cancel',
  clear: 'Clear',
  clear_param: 'Clear {param}',
  start: 'Start',
  pause: 'Pause',
  replace: 'Replace',
  rename: 'Rename',
  skip: 'Skip',
  restart: 'Restart',
  resize: 'Resize',
  setting: 'Setting',
  use: 'Use',
  download: 'Download',
  upload: 'Upload',
  sync: 'Sync',
  tester: 'Tester',
  add: 'Add',
  add_param: ['Add {param}', 'Add {param}'],
  create: 'Create',
  create_param: 'Create {param}',
  save: 'Save',
  saveAs: 'Save As',
  noSave: 'No Save',
  reset: 'Reset',
  open: 'Open',
  minimize: 'Minimize',
  maximize: 'Maximize',
  restitute: 'Restitute',
  transfer: 'Transfer',
  change: 'Change',
  more: 'More',
  hasMore: 'Has more',
  search: 'Search',
  detail: 'Detail',
  exif: 'Exif',
  preview: 'Preview',
  searchType: {
    prefix: 'Prefix search',
    fuzzy: 'Fuzzy search',
    byBucketName: 'Name',
    byBucketTag: 'Tag',
  },
  view: 'View',
  return: 'Return',
  play: 'Play',
  switch: 'Switch',
  import: 'Import',

  // Translations in this namespace are complex actions.
  save_as: 'Save As',
  pause_all: 'Pause All',
  start_all: 'Start All',
  remove_all: 'Delete All',
  remove_finish: 'Clear Finished',
  load_more: 'Load More',
  no_more: 'No More',
  view_on_phone: 'View on phone',
  file_preview: 'File Preview',
  delete_files: 'Delete Files',
  upload_files: 'Upload Files',
  upload_folder: 'Upload Folder',
  resume_upload_folder: 'Resume Upload Folder',
  create_file: 'Create File',
  create_folder: 'Create Folder',
  upload_advance: 'Advanced Upload',
  download_advance: 'Advanced Download',
  download_whole_folder: 'Download Whole Folder',
  setting_advance: 'Advanced Settings',
  copy_link: 'Copy Link',
  select_link: 'Select Link',
  create_temp_link: 'Create temporary object url',
  select_objects: 'Select Objects',
  set_objects: 'Set object properties',
  drag_support: 'Drag and drop files/folders for Chrome and Firefox. You can select multiple files/folders',
  drag_maxsize: 'Each file must be smaller than 512 GB.',
  select_file: 'Select File',
  select_folder: 'Select Folder',
  select_local_folder: 'Select Local Folder',
  create_link_task: 'Add Upload Task',
  add_link_task: 'Add upload link',
  cause_of_failure: 'Cause of failure',
  select_target_folder: 'Select Target Folder',
  param_to_current_folder: '{param} to current folder',
  only_show_once: 'Only show once',
  clear_editor_history: 'Clear History',
  copy_files: 'Copy files',
  move_files: 'Move files',
  share_file_or_folder: 'Share Folders/Files',
  auto_generate: 'Auto generate',
  custom: 'Custom',
  preview_domain_configuration: 'Preview Domain Configuration',
  copy_link_with_sign: 'Preview with signature',
  copy_link_without_sign: 'Preview without signature',
  copy_link_and_extract: 'URL: {url} Extraction Code: {extract}',
  copy_success: 'The URL and extraction code have been copied successfully!',
  // Translations in this namespace are complex paragraph.
  step: ['Next', 'Previous'],
  list_param: '{action} List',
  queue: '{action} Queue',
  cost_time: 'Cost',
  download_now: 'Download now',
  loading: 'Loading...',
  deleting: 'Deleting...',
  listing_files: 'Listing files...',
  checking_files: 'Checking files...',
  renaming_folder: 'Renaming folder...',
  loading_thumbnail: 'Loading thumbnail...',
  consistency_checking: 'Checking',
  list_empty: 'This list is empty',
  keyword_empty: 'This keyword is empty',
  I_know_it: 'I know it!',

  // 同步操作 相关名词
  sync_file: 'File Sync',
  sync_setting: 'Sync Setting',
  sync_log: 'Sync Logs',
  sync_start: 'Start Sync',
  sync_stop: 'Stop Sync',
  sync_auto: 'Auto Sync',
  sync_clear_cache: 'Clear Local Cache',
  sync_clear_cache_success: 'Clear Local Cache successfully',
  sync_tip1: 'If there is a bucket object with the same path as the local file, COSBrowser will upload and overwrite it.',
  sync_tip2: "If you don't want to overwrite, you can open Bucket",
  sync_clear_history: 'Clear History',
  sync_history_empty: 'No History',
  sync_success_param: '{count} files synchronization successful',
  sync_fail_param: '{count} files synchronization failed',
  sync_scanning: 'Scanning...',
  sync_no_changed: 'No file changed',
  sync_syncing: '{count} file changed, uploading files...',
  sync_current_time: 'This synchronization ',
  sync_tips:
    'Support incremental upload only. See the <a href="https://cloud.tencent.cn/document/product/436/38103#synchronization">documentation</a> for details.',
  sync_last_time_param: 'Last synchronization before {duration} ',
  sync_state_map: {
    waiting_hash: 'Waiting',
    waiting_upload: 'Waiting Upload',
    hashing: 'Hashing',
    uploading: 'Uploading',
    paused: 'Paused',
    canceled: 'Canceled',
    error: 'Error',
    success: 'Upload Successfully',
    no_change: 'Same With Remote',
  },
  no_files_upload: 'No files to upload',

  // 状态相关名词
  state_map: {
    start: 'Start {action}',
    waiting: 'Waiting for {action}ing',
    checking: 'Checking',
    doing: [
      '{action}ing', // 0
      '{action}ing', // 1
      'File {action}ing', // 2
    ],
    paused: '{action} paused',
    canceled: '{action} canceled',
    fail: '{action} failed',
    success: '{action} successfully', // 0
  },
  share_permission_map: {
    r: 'Read only',
    rw: 'Read & write',
  },

  // message
  delete_incomplete: 'Delete incomplete',
  deleting_files: 'Deleting files, {count} files has been deleted...',
  delete_files_success: '{count} File / Folder deleted successfully.',
  delete_files_summary: 'Total files {count}, {success} files deleted successfully, {fail} files failed to delete.',
  delete_files_paragraph: [
    '{count} files in total',
    '{count} files deleted successfully',
    '{count} files deleted failed',
    '{count} files were not deleted successfully',
  ],
  start_to_end_file: '{start}-{end} files,',
  get_url_link: 'Get link Url...',
  search_result: [
    '{result} results found with prefix search with keyword \'{keyword}\'',
    '{result} results found with fuzzy search with keyword \'{keyword}\'',
    '{result} results found with name search',
    '{result} results found with tag search',
    '{num} files retrieved, {result} results',
  ],
  sort_result: [
    'Sorting, {result} files have been loaded',
    '{result} files loaded and sorted',
    '{result} files loaded and sorted, reached the upper limit',
  ],
  data_statistics_deadline: 'Data statistics deadline: {time}',
  download_mobile_client: 'Scan the code to download the mobile client',
  only_show_200_record: 'Only show 200 records',
  get_no_password_from_system: 'No password was retrieved from the system. Whether to refresh the page?',
  open_with_encode_param: 'Open with {encode} encoding',
  open_with_other_encode: 'Open in other encoding format',
  convert_to_encode_param: 'Convert to {encode} encoding',
  convert_to_other_encode: 'Convert to other encoding format',
  keep_historical_record_param: 'Keep only {num} historical records.',
  confirm_delete_record: 'Are you sure you want to delete {name}？',
  confirm_clear_edit_history:
    'Are you sure to clear the editing history? (Once cleared, the original edited file cannot be retrieved)',
  confirm_to_save: 'Are you sure to save?',
  params_be_pasted: '4 files/folders will be pasted.',
  conflict_paste: 'The target location already contains the following files/folders with the same name, please choose your operation:',
  share_folders_name_params: '{name}',

  // 分页
  pagination: {
    items: 'items',
    item: 'item',
    checked: 'selected',
    total: 'Total',
    linesPerPage: 'Item per page',
    firstPage: 'First page',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    lastPage: 'Last page',
    pageIndex: 'Page {index}',
    itemPulled: '{num} items pulled',
  },

  // edit files
  edit_exit_tips: 'file has been modified, save changes?',
  edit_reading_file: 'reading file',
  edit_reading_error: 'file read error ',
  still_edit: 'Edit',
  edit_unsaved: 'Unsaved',
  edit_saving: 'Saving',

  // 图片EXIF属性
  exif_name: 'name',
  exif_explanation: 'explanation',
  exif_value: 'value',
  exif_map: {
    ExifVersion: 'Exif Version',
    FlashPixVersion: 'FlashPix Version',
    ColorSpace: 'Color Space',
    PixelXDimension: 'Effective width of the image',
    PixelYDimension: 'Effective height of the image',
    ComponentsConfiguration: 'Image Construction',
    CompressedBitsPerPixel: 'Color bits per pixel when compressed',
    MakerNote: 'Information set by the manufacturer',
    UserComment: 'User comment',
    RelatedSoundFile: 'Associated sound file',
    DateTimeOriginal: 'Creation time',
    DateTimeDigitized: 'Digital creation time',
    SubsecTime: 'Date time (seconds)',
    SubsecTimeOriginal: 'Original date and time (seconds)',
    SubsecTimeDigitized: 'Digitization of the original date and time (seconds)',
    ExposureTime: 'Exposure Time',
    FNumber: 'Aperture Value',
    ExposureProgram: 'Exposure Procedure',
    SpectralSensitivity: 'Spectral Sensitivity',
    ISOSpeedRatings: 'Sensitivity',
    OECF: 'Photoelectric conversion function',
    ShutterSpeedValue: 'Shutter Speed',
    ApertureValue: 'Lens Aperture',
    BrightnessValue: 'Brightness',
    ExposureBiasValue: 'Exposure Compensation',
    MaxApertureValue: 'Maximum Aperture',
    SubjectDistance: 'Object Distance',
    MeteringMode: 'Metering Method',
    Lightsource: 'Light Source',
    Flash: 'Flash',
    SubjectArea: 'Main Area',
    FocalLength: 'Focal Length',
    FlashEnergy: 'Flash Intensity',
    SpatialFrequencyResponse: 'Spatial frequency response',
    FocalPlaneXResolution: 'Focal length plane X axis resolution',
    FocalPlaneYResolution: 'Focal length plane Y axis resolution',
    FocalPlaneResolutionUnit: 'Focal length plane resolution unit',
    SubjectLocation: 'Subject position',
    ExposureInde: 'Exposure index',
    SensingMethod: 'Image sensor type',
    FileSource: 'Source File',
    SceneType: 'Scene type',
    CFAPattern: 'CFA mode',
    CustomRendered: 'Custom image processing',
    ExposureMode: 'Exposure mode',
    WhiteBalance: 'White balance',
    DigitalZoomRation: 'Digital zoom',
    FocalLengthIn35mmFilm: '35mm film focal length',
    SceneCaptureType: 'Scene shooting type',
    GainControl: 'Scene shooting type',
    Contrast: 'Contrast',
    Saturation: 'Saturation',
    Sharpness: 'Sharpness',
    DeviceSettingDescription: 'Device setting description',
    SubjectDistanceRange: 'Subject distance range',
    ImageUniqueID: 'Image unique ID',
    ImageWidth: 'Image width',
    ImageHeight: 'Image height',
    BitsPerSample: 'Bit sampling rate',
    Compression: 'Compression method',
    PhotometricInterpretation: 'Pixel synthesis',
    Orientation: 'Shooting direction',
    SamplesPerPixel: 'Pixels',
    PlanarConfiguration: 'Data arrangement',
    YCbCrSubSampling: 'Hue sampling ratio',
    YCbCrPositioning: 'Hue configuration',
    XResolution: 'X direction resolution',
    YResolution: 'Y direction resolution',
    ResolutionUnit: 'Resolution unit',
    StripOffsets: 'Image data location',
    RowsPerStrip: 'Lines per band',
    StripByteCounts: 'Bits per compression',
    JPEGInterchangeFormat: 'JPEG SOI offset',
    JPEGInterchangeFormatLength: 'JPEG bits',
    TransferFunction: 'Transfer function',
    WhitePoint: 'White point chromaticity',
    PrimaryChromaticities: 'Main chroma',
    YCbCrCoefficients: 'Color space conversion matrix coefficients',
    ReferenceBlackWhite: 'Black and white reference value',
    DateTime: 'Date and time',
    ImageDescription: 'Image description',
    Make: 'Producer',
    Model: 'Model',
    Software: 'Software',
    Artist: 'Author',
    Copyright: 'Copyright',
    GPSVersionID: 'GPS Version',
    GPSLatitudeRef: 'GPS Latitude Ref',
    GPSLatitude: 'GPS Latitude',
    GPSLongitudeRef: 'GPS Longitude Ref',
    GPSLongitude: 'GPS Longitude',
    GPSAltitudeRef: 'GPS Altitude Ref',
    GPSAltitude: 'GPS Altitude',
    GPSTimeStamp: 'GPS time stamp',
    GPSSatellites: 'GPS Satellites',
    GPSStatus: 'GPS Status',
    GPSMeasureMode: 'GPS Measure Mode',
    GPSDOP: 'measurement accuracy',
    GPSSpeedRef: 'GPS Speed Ref',
    GPSSpeed: 'GPS Speed',
    GPSTrackRef: 'GPS Track Ref',
    GPSTrack: 'GPS Track',
    GPSImgDirectionRef: 'GPS ImgDirection Ref',
    GPSImgDirection: 'Image orientation',
    GPSMapDatum: 'Geodetic data',
    GPSDestLatitudeRef: 'Target longitude reference',
    GPSDestLatitude: 'Target latitude',
    GPSDestLongitudeRef: 'Target longitude reference',
    GPSDestLongitude: 'Target longitude',
    GPSDestBearingRef: 'Target orientation reference',
    GPSDestBearing: 'Target bearing',
    GPSDestDistanceRef: 'Target distance reference',
    GPSDestDistance: 'Target distance',
    GPSProcessingMethod: 'GPS processing method name',
    GPSAreaInformation: 'GPS area function variable name',
    GPSDateStamp: 'GPS date',
    GPSDifferential: 'GPS correction',
  },
  // 元数据
  meta_data: 'Meta Data',
  meta_val: 'Value',
  meta_params: 'Params',
  meta_option: 'Option',
  meta_add_params: 'Add Params',
  meta_select_project: 'Select Project',
  meta_delete: 'Delete',
  meta_option_tips:
    'Object property settings will be applied to all objects to be uploaded, you can also set directly on the file list page after the upload is complete.',

  // 归档取回
  recovery_mode: 'Recovery Mode',
  restore_mode_standard: 'Standard',
  restore_mode_expedited: 'Expedited',
  restore_mode_bulk: 'Bulk',
  restore_archived_objects: 'Restore objects that has been archived or deep archived',
  no_later_than: 'Download a copy after {time} at the latest',
  extreme_speed_mode_only_supports_objects_within_256MB: 'Extreme speed mode only supports objects within 256MB',
  restore_copy_validity: 'Restore copy validity',
  please_enter_the_number_of_days: 'Please enter the number of days',
  the_copy_will_be_automatic_expired_deletion: 'The copy will be deleted automatically after {time}',
  restore_the_restored_copy_will_be_deleted: 'The copy has been retrieved, and the copy will be automatically deleted after {deleteTime}',
  recovery_input_rules: 'Please enter an integer number of days, the minimum is 1, the maximum is 365',
  resortErrorMessage: {
    notArchive: 'The file is not archive storage',
  },
  restore_estimated_time: 'Estimated Time',
  restore_the_copy_can_be_downloaded: 'The copy can be downloaded after the expected time in recovery mode',
  restore_the_copy_will_be_deleted: 'The copy will be automatically deleted after {deleteTime}',
  restore_copy_rescheduled: 'Copy rescheduled',
  restore_copy_time_map: {
    standard: 'Standard mode 3~5 hours',
    expedited: 'Speed ​​mode 1~5 minutes',
    bulk: 'Batch mode 5~12 hours',
  },
  restore_status_map: {
    unrestore: 'Archive storage',
    restoring: 'Recovering copy',
    restored: 'Copy restored',
  },
  urlUpload: 'URL Upload',
  collection_path: 'Bookmark Path',
  bucket_list: 'Bucket List',
  favorite: 'Add Bookmark',
  unfavorite: 'Remove',
  ErrorCode: 'Error code',
  PrefixConfiguration: 'Prefix configuration',
  TencentCloud: 'Tencent Cloud',
  EtgError: 'ETag retrieval failed. Please add "ETag" to the CORS ExposeHeader setting. Please refer to the documentation.https://www.tencentcloud.com/document/product/436/13318',
  ContentLengthError: 'If you encounter a "Content-Length" error, please add "Content-Length" to your CORS ExposeHeader settings. (For more information, please refer to the documentation: https://cloud.tencent.com/document/product/436/13318)',
  NoSuchSid: 'The link does not exist',
  ExpiredUrl: 'The link is no longer valid',
  ErrorExtractCode: 'The extraction code is invalid. Please try again',
  GetAccessCodeWrong: 'Decoding failed. Please try again',
  PleaseEnterCode: 'Please enter the 6-digit verification code',
  InternetError: 'The network is congested. Please refresh the page',
  LoginExpireTime: 'Your session has expired. Please log in again.',
  PleaseEnterKeyAndValue: 'Please provide both the tag key and tag value',
  EnterProductError: "'The tag key cannot start with '项目', 'project', or 'qcs:",
  MaxKey127: 'The tag key length cannot exceed 127 characters',
  MaxKey255: 'The tag value length cannot exceed 255 characters',
  KeyRepeat: 'Tag keys cannot be duplicated',
};
